// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3SMXl","consentsList":"PatientConsents_consentsList__sPEDU","consentsListEmpty":"PatientConsents_consentsListEmpty__1P83G"};